"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputMapping = exports.inputMappingParam = void 0;
exports.getInputMapping = getInputMapping;
var translation_1 = __importDefault(require("../services/translation"));
// need to add each key here for easier access
// key needs to be the same as the key in the inputMapping
var inputMappingParam;
(function (inputMappingParam) {
    inputMappingParam["firstname"] = "firstname";
    inputMappingParam["lastname"] = "lastname";
    inputMappingParam["telephone_mobile"] = "telephone_mobile";
    inputMappingParam["email"] = "email";
    inputMappingParam["gender"] = "gender";
    inputMappingParam["genderDropdown"] = "genderDropdown";
    inputMappingParam["dateOfBirth"] = "dateOfBirth";
    inputMappingParam["street"] = "street";
    inputMappingParam["houseNumber"] = "houseNumber";
    inputMappingParam["zip"] = "zip";
    inputMappingParam["city"] = "city";
    inputMappingParam["country"] = "country";
    inputMappingParam["participantCount"] = "participantCount";
})(inputMappingParam || (exports.inputMappingParam = inputMappingParam = {}));
// returns a FieldMapping based on the type with overwrites
function getInputMapping(type, overwrites) {
    var _a;
    if (overwrites === void 0) { overwrites = {}; }
    var selection = __assign(__assign({}, exports.inputMapping[type]), overwrites);
    return _a = {}, _a[type] = selection, _a;
}
exports.inputMapping = {
    // customer info
    firstname: {
        legacy: { id: '#firstName', id2: '#Vorname', localStorage: 'Vorname' },
        uid: 'customer.firstname',
        required: true,
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidFirstname'),
        type: 'text',
    },
    lastname: {
        legacy: { id: '#lastName', id2: '#Nachname', localStorage: 'Nachname' },
        uid: 'customer.lastname',
        required: true,
        regex: /^\D{2,}$/,
        regexError: translation_1.default.t('noValidLastname'),
        type: 'text',
    },
    telephone_mobile: {
        legacy: {
            id: '#telephone_mobile',
            id2: '#telefon',
            localStorage: 'Telefon',
        },
        uid: 'customer.telephone_mobile',
        required: true,
        regex: /^(\d|\+)\d{4,}$/, //starting with digit or + with at least 5 digits 0-9
        regexError: translation_1.default.t('noValidPhoneNumber'),
        type: 'text',
    },
    email: {
        legacy: { id: '#eMail', localStorage: 'E-Mail' },
        uid: 'customer.email',
        required: true,
        regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/,
        regexError: translation_1.default.t('noValidEmail'),
        type: 'text',
    },
    gender: {
        legacy: {
            id: 'input[name="gender"]:checked',
            localStorage: 'Geschlecht',
        },
        uid: 'customer.gender',
        required: false,
        type: 'radio',
        regex: /(MALE|FEMALE|UNISEX)/,
    },
    genderDropdown: {
        legacy: {
            id: 'input[name="gender"]:checked',
            localStorage: 'Geschlecht',
        },
        uid: 'customer.gender',
        required: false,
        type: 'dropdown',
        regex: /(MALE|FEMALE|UNISEX)/,
    },
    dateOfBirth: {
        legacy: { id: '#dateOfBirth', localStorage: 'birthday' },
        uid: 'customer.dateOfBirth',
        required: false,
        regex: /^\d{4}-\d{2}-\d{2}$/,
        regexError: translation_1.default.t('noValidBirthday'),
    },
    zipCode: {
        legacy: { id: '#zipCode' },
        uid: 'customer.zipCode',
        required: false,
        regex: /^\d{3,7}$/,
        regexError: translation_1.default.t('noValidZIP'),
        type: 'text',
    },
    houseNumber: {
        legacy: { id: '#houseNumber' },
        uid: 'customer.houseNumber',
        required: false,
        regex: /^.+$/,
        regexError: translation_1.default.t('noValidHousenumber'),
        type: 'text',
    },
    city: {
        legacy: { id: '#localCity' },
        uid: 'customer.city',
        required: false,
        regex: /^.{2,}$/,
        regexError: translation_1.default.t('noValidCity'),
        type: 'text',
    },
    street: {
        legacy: { id: '#streetAdress' },
        uid: 'customer.street',
        required: false,
        regex: /^.{2,}$/,
        regexError: translation_1.default.t('noValidStreetName'),
        type: 'text',
    },
    countryCode: {
        legacy: { id: '#countryCode', localStorage: 'countryCode' },
        uid: 'customer.countryCode',
        defaultValue: 'DE',
        required: true,
        type: 'text',
    },
    participantCount: {
        uid: 'participants',
        defaultValue: '1',
        required: false,
        type: 'text',
        regex: /^\d{1,}$/,
        regexError: translation_1.default.t('Invalid participants.'),
    },
};
